import * as React from 'react';
import { useMemo } from 'react';

import { CombinedPackageViewProps } from '../../components/list/package';
import ListPerformances from '../../components/list/performances';
import { IPerformance } from '../../custom/classes/production';

interface ISuperPackagePerformanceListingData {
    theme: string;
    performances: Array<IPerformance>;
    facilityDescription: string;
}

const ListSuperPackageView: React.StatelessComponent<CombinedPackageViewProps> = (props: CombinedPackageViewProps) => {

    const selectSubscriptionButton = (
        <button className="btn" onClick={() => {
            props.selectedPackage && props.useUnseatedReserve ?
                props.removeFromCart(props.package.id)
                : props.selectPackage(props.package, props.useUnseatedReserve);
        }}>
            {props.selectedPackage && props.useUnseatedReserve ? props.text.removeButtonText : props.text.selectSubscriptionButtonText}
        </button>
    );

    const packageData: Array<ISuperPackagePerformanceListingData> = useMemo(() => {
        return props.package.subPackages.map(subpackage => {
            const theme = subpackage.performanceGroupDetails[0].theme;
            const performances = subpackage.performanceGroupDetails
                .flatMap(pg => pg.appProductions.flatMap(prod => prod.performances));
            const facilityDescription = (performances && performances.length > 0) ? performances[0].facility.facilityDescription : "";

            return {
                theme,
                performances,
                facilityDescription
            }
        });
    }, [props.package, props.filterFunction]);

    return (
        <li key={props.package.id} data-package-id={props.package.id} className="ace-subs-item">
            <article>
                <div className="ace-subs-item-header align-items-center">
                    <h3>
                        {props.package.title}
                    </h3>
                    <div className="ace-subs-item-select ace-hide-for-tablet">
                        {selectSubscriptionButton}
                    </div>
                </div>
                <div className="ace-production grid grid-4-8 space-top-md">
                    <div className="ace-production-content">
                        <div className={`rich-text stack-sm ${props.themeClass}`}>
                            <p className="h6-style themed-location">
                                <svg className={props.package.facility.facilityDescription ? "svg-icon" : "svg-icon-stroke" + " svg-icon-text"} aria-hidden="true" focusable="false">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                </svg>

                            {
                                props.package.facility.facilityDescription ?
                                        <span className="icon-location-title notranslate">{props.package.facility.facilityDescription}</span>
                                    : <span className="h6-style"> Multiple Venues </span>
                            }
                            </p>
                            {
                                props.package.numberOfPerformancesMessage ?
                                    <p className="small">{props.package.numberOfPerformancesMessage}</p>
                                    : null
                            }


                        </div>
                        <button className={`btn-secondary space-top-md dropdown-trigger ${props.showPerformances ? 'dropdown-trigger-up' : 'dropdown-trigger-down'}`}
                            onClick={props.toggleShowPerformances}>
                            {
                                props.showPerformances ? props.text.hidePerformancesText
                                    : props.text.showPerformancesText
                            }
                        </button>

                    </div>

                    <div className="">
                        <div className={props.showPerformances ? "show ace-production-filtered-performances stack-sm" : "hide"}>
                            {
                                packageData.map(({ theme, performances, facilityDescription }) => {
                                    return <div key={facilityDescription}>

                                        <ListPerformances
                                            filteredPerformances={performances}
                                            toggleShowPerformances={props.toggleShowPerformances}
                                            theme={theme}
                                            facilityDescription={facilityDescription}
                                        />
                                    </div>
                                })
                            }
                        </div>
                        <div className="ace-show-for-tablet">
                            {selectSubscriptionButton}
                        </div>
                    </div>
                </div>

            </article>
        </li>
    )
}

export default ListSuperPackageView;